import React, { useState } from "react";
import * as Yup from "yup";

import { Button } from "components/Button";
import { CommentsTextArea } from "components/CommentsTextArea";

import { useToast } from "hooks/toast";
import getValidationErrors from "utils/getValidationErrors";
import { containsEscapeCharacters } from "utils/containsEscapeCharacters ";

import * as S from "./styles";
import apiv2 from "services/apiv2";

type ObservationItems = {
  id: string;
  message: string;
};

type Errors = {
  [key: string]: string;
};

type Props = {
  handleToggleOpen: () => void;
  editObservation: ObservationItems | null;
};

export function EditObservation({ handleToggleOpen, editObservation }: Props) {
  const { addToast } = useToast();

  const [value, setValue] = useState(
    editObservation && editObservation.message ? editObservation.message : ""
  );

  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState<Errors>({} as Errors);
  const [hasErrorOnValue, setHasErrorOnValue] = useState("");

  async function handlePostTextDefault() {
    if (!editObservation) return;

    if (containsEscapeCharacters(value)) {
      setHasErrorOnValue('Não é permitido uso de barra invertida "\\"');
      addToast({
        title: "Ops!!",
        description: 'Não é permitido uso de barra invertida "\\"',
        type: "error",
      });

      return;
    } else {
      setHasErrorOnValue("");
    }

    try {
      const schema = () => {
        return Yup.object().shape({
          value: Yup.string().required("Texto padrão é obrigatório"),
        });
      };

      await schema().validate({ value }, { abortEarly: false });

      setLoading(true);

      await apiv2.put(`/budgets/default-observations/${editObservation?.id}`, {
        message: value.trim(),
      });

      addToast({
        title: "Sucesso",
        description: "Mensagem editada com sucesso",
        type: "success",
      });

      handleToggleOpen();
      setHasError({} as Errors);
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        setHasError(errors);
        return;
      }

      addToast({
        title: "Ops, erro ao editar texto padrão",
        type: "error",
        description: "",
      });
    } finally {
      setLoading(false);
      setValue("");
    }
  }

  return (
    <S.Container>
      <CommentsTextArea
        value={value}
        onChange={(e) => setValue(e.target.value.trimStart())}
        hasError={hasError.value || hasErrorOnValue}
        onFocusClearError={() => setHasError({} as Errors)}
        style={{ height: "220px" }}
      />

      <div>
        <Button loading={loading} onClick={() => handlePostTextDefault()}>
          Editar texto padrão
        </Button>
      </div>
    </S.Container>
  );
}
